import * as React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

export default function BasicTextFields({
  val,
  name,
  label,
  handleChange,
  isWidthFull = false,
  isError,
  handleFocus,
  inputType = "text",
  isDisabled=false
}) {
  return (
    <TextField
      name={name}
      id="outlined-basic"
      value={val}
      onChange={handleChange}
      label={label}
      variant="outlined"
      size="small"
      type={inputType}
      onFocus={handleFocus && handleFocus}
      disabled={isDisabled}
      sx={{
        width: isWidthFull ? "100%" : "auto",
        "& .MuiOutlinedInput-root": {
          borderRadius: "12px", // Custom border radius
        },
        borderRadius: "12px",
        border: isError ? "1px solid red" : "",
      }}
    />
  );
}
